/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteExpenseItemInput = {|
  id?: ?string,
  projectId?: ?string,
  companyProjectId?: ?number,
  companyId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteExpenseItemMutationVariables = {|
  input: DeleteExpenseItemInput
|};
export type deleteExpenseItemMutationResponse = {|
  +deleteExpenseItem: ?{|
    +deletedExpenseItemId: ?string
  |}
|};
export type deleteExpenseItemMutation = {|
  variables: deleteExpenseItemMutationVariables,
  response: deleteExpenseItemMutationResponse,
|};
*/


/*
mutation deleteExpenseItemMutation(
  $input: DeleteExpenseItemInput!
) {
  deleteExpenseItem(input: $input) {
    deletedExpenseItemId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteExpenseItemInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteExpenseItemPayload",
    "kind": "LinkedField",
    "name": "deleteExpenseItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedExpenseItemId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteExpenseItemMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteExpenseItemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteExpenseItemMutation",
    "operationKind": "mutation",
    "text": "mutation deleteExpenseItemMutation(\n  $input: DeleteExpenseItemInput!\n) {\n  deleteExpenseItem(input: $input) {\n    deletedExpenseItemId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '53a9f5382ff7b4c64ab49bf27a2fc0ea';

module.exports = node;
